<template>
  <KTCard ref="preview" v-bind:title="title" v-bind:example="true" id="dashboard-box">
<!--    <template v-slot:title v-if="hasTitleSlot">-->
<!--      <h3 class="card-title">-->
<!--         <span class="svg-icon back-button-color svg-icon-2x cursor-pointer mr-2" v-if="back" @click="backButton()">-->
<!--           <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">-->
<!--             <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
<!--               <polygon points="0 0 24 0 24 24 0 24"/>-->
<!--               <path d="M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z" fill="#000000" fill-rule="nonzero" transform="translate(12.000003, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-12.000003, -11.999999) "/>-->
<!--             </g>-->
<!--           </svg>-->
<!--         </span>-->
<!--        <slot name="buttons"></slot>-->
<!--        <slot name="title"></slot>-->
<!--      </h3>-->
<!--    </template>-->
    <template v-slot:toolbar>
      <slot name="toolbar"></slot>
    </template>
    <template v-slot:body>
      <slot name="preview"></slot>
    </template>
  </KTCard>
</template>
<script>
import KTCard from "@/view/content/Card.vue";
export default {
  name: "DashboardBox",
  props: {
    title: String,
    back: Boolean,
    backComponentName: String
  },
  data() {
    return {
      tabIndex: 0,
      isOpen: false
    };
  },
  components: {
    KTCard
  },
  mounted() {
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll('[data-toggle="tab"]');
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }
      // set current active tab
      event.target.classList.add("active");
      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));
    },
    backButton () {
      if (this.backComponentName) {
        this.$router.push({name: this.backComponentName})
      } else {
        this.$router.go(-1)
      }
      this.$emit('back')
    }
  },
  computed: {
    /**
     * Check if has title
     * @returns {boolean}
     */
    hasTitleSlot() {
      return !!this.$slots["title"];
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/sass/components/_variables.demo.scss';
.back-button-color {
  color: $primary !important
}
#dashboard-box{
  border-radius: 25px;
  padding: 30px !important;
}
</style>
